import React from "react";
import { useParams } from "react-router-dom"
import HomesleepLink from "./homesleepq";
import ViewPhq9link from "../ph9link";
import MdqLink from "../mdqlink";
import AsrsLink from "../asrslink";
import MmseLink from "../msme";
import StopBangLink from "../banglink";


const DocumentLinkSwitcher = () => {
  const { type } = useParams();

  const renderDocument = () => {
    switch (type?.toLowerCase()) {
 case "homesleep":
    return <HomesleepLink />;

  case "phq9":
    return <ViewPhq9link />;

  case "mdq":
    return <MdqLink />;

  case "asrs":
    return <AsrsLink />;

  case "mmse":
    return <MmseLink />;

  case "stopbang":
    return <StopBangLink />;
      // case "otherform": 
      //   return <OtherFormComponent />;

      // case "intake":
      //   return <IntakeFormComponent />;

      default:
        return (
          <div className="flex items-center justify-center h-screen text-xl font-semibold text-red-600">
            Invalid Document Type: {type}
          </div>
        );
    }
  };

  return <>{renderDocument()}</>;
};

export default DocumentLinkSwitcher;
